import { CreatePackRequestBody } from "../apis/useCreatePack";
import { PackFormValues } from "../packs.types";

const toNumberOrZero = (value: unknown): number => {
  if (value == null || value === "") return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const convertPackFormDataToCreateRequestBody = (
  formData: PackFormValues
): CreatePackRequestBody => {
  return {
    title: formData.title.trim(),
    shortId: formData.shortId.trim(),
    description: formData.description.trim() || undefined,
    mediaIds: formData.media.map((m) => m.id),
    previewId: formData.preview?.id ?? undefined,
    badgeId: formData.badgeId || undefined,
    price: Number(formData.price),
    merchantPrice: toNumberOrZero(formData.merchantPrice),
    intermediateResellerPrice: toNumberOrZero(formData.intermediateResellerPrice),
    confirmedResellerPrice: toNumberOrZero(formData.confirmedResellerPrice),
    influencerPrice: toNumberOrZero(formData.influencerPrice),
    recommendedSellingPrice: toNumberOrZero(formData.recommendedSellingPrice),
    commission: toNumberOrZero(formData.commission),
    commissionPercentage: toNumberOrZero(formData.commissionPercentage),
    influencerCommission: toNumberOrZero(formData.influencerCommission),
    influencerCommissionPercentage: toNumberOrZero(
      formData.influencerCommissionPercentage
    ),
    discount: toNumberOrZero(formData.discount),
    discountAmount: toNumberOrZero(formData.discountAmount),
    allowSellingBelowBuyingPrice: formData.allowSellingBelowBuyingPrice,
    isActive: formData.isActive,
    isChapshopChoice: formData.isChapshopChoice,
    position: formData.position,
    slots: formData.slots.map((slot, slotIndex) => ({
      title: slot.title.trim(),
      position: slotIndex,
      options: slot.options.map((option, optionIndex) => ({
        productVariantId: option.productVariantId,
        position: optionIndex
      }))
    }))
  };
};
